import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-five',
  templateUrl: './home-five.component.html',
  styleUrls: ['./home-five.component.scss']
})
export class HomeFiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
